import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errors: [],
  filterModal: false,
  loading: false,
  pageTitle: null,
};

const uiSlice = createSlice({
  name: "uiContext",
  initialState,
  reducers: {
    addError: (state, { payload }) => {
      state.errors = [...state.errors, payload];
    },
    clearErrors: (state, action) => {
      state.errors = [];
    },
    closeError: (state, { payload }) => {
      state.errors = state.errors.map((error) =>
        error.id === payload ? { ...error, dismissed: true } : error
      );
    },
    hideFilterModal: (state, action) => {
      state.filterModal = false;
    },
    showFilterModal: (state, action) => {
      state.filterModal = true;
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
    startLoading: (state, action) => {
      state.loading = true;
    },
    stopLoading: (state, action) => {
      state.loading = false;
    },
  },
});

export const {
  addError,
  clearErrors,
  closeError,
  hideFilterModal,
  setPageTitle,
  showFilterModal,
  startLoading,
  stopLoading,
} = uiSlice.actions;

export default uiSlice.reducer;
